import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test140925 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 14/09/2025 Candidates</h3>
      <br />
      <br />



        <div><Link to='/conduct-jarunnops'>1. AAT 7561  MR.JARUNNOP SIRIVORAPAIBOON(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-autp'>2. AAT 7761  CDR.AUT PANGPASSA(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>3. AAT 7832  CPO1.SUPACHAI SITTIRUK(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-metapornc'>4. AAT 7833  MS.METAPORN CHIM-IM(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>5. AAT 7779  MS.KANOKPHON CHAIYAWONG(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-rattapongp'>6. AAT 4478  LTJG.RATTAPONG PONGSUWAN(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>7. AAT 7923  MR.THOMAS MOENKEMEIER(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>8. ATT  7910  MR.NAPOL PITAYAPAT(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>9. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>10. AAT 7783  LT.NIRUN CHANTAWARO(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>11. AAT 7972  CPO1.SUNYA LAEID(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-jamesrh'>12. AAT 8003  MR.JAMES RICKY HEBBLETHWAITE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-natthapony'>13. AAT 8004  MR.NATTHAPON YATAN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>14. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>15. AAT 8006  MS.NUEA SUDRAK(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marceld'>16. AAT 8024  MR.MARCEL DEKE(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-watcharapongb'>17. AAT 8025  LT.WATCHARAPONG BUMRUNGKLANG(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanyaphatp'>18. AAT 8026  MS.KANYAPHAT PRIYACHANASAKUL(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>19. AAT 8027  MS.BARBARA BARZARKINA(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-nannaphatp'>20. AAT 8028  ​MS.NANNAPHAT PRIYACHANASAKUL(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>21. AAT 8029  MS.PANYASUPHA KHEMARUT(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-kank'>22. AAT 8030  MR.KAN KAIWANNON(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-natdanaid'>23. AAT 8031  MR.NATDANAI DOUNGRATSAMEE(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-athichonmf'>24. AAT 8032  MR.ATHICHONM FUANGKAEW(WB)---Trying for 10KYU</Link></div>
        <br />





        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test140925;
